import { cn } from "@/lib/utils";

type MartinaAvatarProps = {
  active?: boolean;
  listening?: boolean;
  size?: "sm" | "md";
  className?: string;
};

export function MartinaAvatar({
  active = false,
  listening = false,
  size = "md",
  className,
}: MartinaAvatarProps) {
  const box = size === "sm" ? "h-8 w-8" : "h-10 w-10";
  const pulse = active || listening;

  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center",
        box,
        className,
      )}
      aria-hidden="true"
    >
      {pulse && (
        <span className="absolute inset-0 animate-ping border border-primary/40 bg-primary/10" />
      )}
      <span className="group/avatar relative inline-flex h-full w-full items-center justify-center overflow-hidden border border-primary/40 bg-background shadow-sm transition-transform motion-safe:group-hover:-translate-y-0.5">
        <svg
          viewBox="0 0 48 48"
          className={cn(
            "h-full w-full transition-transform duration-300 motion-safe:group-hover:scale-105",
            pulse && "animate-pulse",
          )}
          role="img"
          aria-label="Martina"
        >
          <rect width="48" height="48" fill="#eef2ff" />
          <path
            d="M11 40c1.2-8.4 6.2-12.2 13-12.2S35.8 31.6 37 40H11Z"
            fill="#6366f1"
          />
          <path
            d="M14.5 22.8c-.4-8.5 4.5-15 11-15 7.1 0 11.1 6.1 9.7 15.1-1.3 8.4-5.2 11.6-10.4 11.6-5.7 0-9.9-3.7-10.3-11.7Z"
            fill="#f6c44f"
          />
          <path
            d="M16.7 23.2c0-6.5 3.2-10.5 8.3-10.5 5.2 0 8.3 4 8.3 10.5 0 6.3-3.2 10.4-8.3 10.4-5.1 0-8.3-4.1-8.3-10.4Z"
            fill="#ffd6c2"
          />
          <path
            d="M15.1 22.2c.2-7.2 4.1-12.9 10.4-12.9 4.6 0 8.1 2.8 9.5 7.6-5.8.4-10.6-1-14.3-4.2-1.3 3.4-3.1 6.3-5.6 9.5Z"
            fill="#f1b83b"
          />
          <path
            d="M12.6 23.4c0-7.8 4.9-15.7 12.6-15.7 7.3 0 11.6 5.8 11.1 14.7"
            fill="none"
            stroke="#374151"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <rect x="10" y="21" width="5.8" height="9.2" rx="1.4" fill="#374151" />
          <rect x="34" y="21" width="5.8" height="9.2" rx="1.4" fill="#374151" />
          <path
            d="M37.6 28.6c-.5 4.2-3.4 6.7-8.6 7.4"
            fill="none"
            stroke="#374151"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle
            cx="28.3"
            cy="36.2"
            r="1.8"
            className={pulse ? "fill-primary" : "fill-[#374151]"}
          />
          <circle cx="21.8" cy="24" r="1.2" fill="#374151" />
          <circle cx="29.2" cy="24" r="1.2" fill="#374151" />
          <path
            d="M22.3 29.1c1.4 1.1 4.1 1.1 5.5 0"
            fill="none"
            stroke="#b45309"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </span>
    </span>
  );
}
